import React from "react";
import scrollToComponent from "react-scroll-to-component";

const GoButton = ({ style, targetRefForScroll }) => {
  return (
    <div className="go-button-container">
      <button
        onClick={() =>
          scrollToComponent(targetRefForScroll.current, {
            offset: 0,
            align: "top",
            duration: 2200,
          })
        }
        className="go-button"
        style={style}
      >
        <p className="go-button-text">WHY WE CARE</p>
        <svg
          className="arrow"
          viewBox="0 0 60 82"
          preserveAspectRatio="xMidYMid meet"
        >
          <path className="a1" d="M0 0 L30 22 L60 0"></path>
          <path className="a2" d="M0 20 L30 42 L60 20"></path>
          <path className="a3" d="M0 40 L30 62 L60 40"></path>
        </svg>
      </button>
    </div>
  );
};

export default GoButton;
